import Chips from './chips'

export const AmuiChips = Chips

export default Vue => Vue.component(Chips.name, Chips)
